module.exports = __webpack_public_path__ + "static/img/craig-whitehead-JwEfmd6aFzY-unsplash_thumb.e1aad7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/craig-whitehead-JwEfmd6aFzY-unsplash_thumb.png
// module id = mQXd
// module chunks = 4